/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Xml_HintInputs */

const cs_listing_portals_xml_hint = /** @type {(inputs: Listing_Portals_Xml_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý portál má vlastní URL. Vložte ji do administrace portálu jako Sreality-kompatibilní XML import.`)
};

const en_listing_portals_xml_hint = /** @type {(inputs: Listing_Portals_Xml_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each portal has its own URL. Paste it into the portal admin as a Sreality-compatible XML import.`)
};

/**
* | output |
* | --- |
* | "Each portal has its own URL. Paste it into the portal admin as a Sreality-compatible XML import." |
*
* @param {Listing_Portals_Xml_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_xml_hint = /** @type {((inputs?: Listing_Portals_Xml_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Xml_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_xml_hint(inputs)
	return cs_listing_portals_xml_hint(inputs)
});